import { EnumDropdown } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';
import { REJECTION_REASONS } from '../constants';
import applicationRejectCandidateValidation from '../validation/applicationRejectCandidateValidation';

type ApplicationRejectCandidateDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const REJECT_CANDIDATE_SECTIONS: CreateEditFormSection[] = [
  {
    id: 'rejection',
    fields: [
      {
        id: 'rejectionReason',
        size: { xs: 12, md: 8, xl: 8 },
        content: (
          <EnumDropdown
            source="rejectionReason"
            label="Rejection Reason"
            placeholder="Select rejection reason"
            options={REJECTION_REASONS}
            isRequired
          />
        ),
      },
    ],
  },
];

const ApplicationRejectCandidateDrawer = ({ isOpen, onClose }: ApplicationRejectCandidateDrawerProps) => (
  <CreateEditFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    title="Reject candidate"
    header="Indicate rejection reason based on decision details provided by staffing coordinator"
    isCreateRequest
    getValidationSchemaFunc={() => Promise.resolve(applicationRejectCandidateValidation)}
    submitFormFunc={async () => {}}
    afterSubmit={{ execute: onClose }}
    submitButtonTitle="Reject"
    handleDirty={false}
    getSections={() => REJECT_CANDIDATE_SECTIONS}
  />
);

export default ApplicationRejectCandidateDrawer;
